var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolighus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(0.467 0.158)",
    fill: "#b7dc8f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolighus",
    transform: "translate(-201 -358)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97-2",
    "data-name": "Ellipse 97",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(201 358)",
    fill: "#b7dc8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(200.533 357.842)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(10.88 10.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 28.879,
    height: 31.509,
    transform: "translate(1.342 10.811)",
    fill: "#ffc646"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 14.692,
    height: 17.878,
    transform: "translate(8.268 24.443)",
    fill: "#fca44c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 14.692,
    height: 5.962,
    transform: "translate(8.268 24.443)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 28.879,
    height: 2.491,
    transform: "translate(1.342 10.811)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M31.388,14.189H.751L1.862,5.351H30.277Z",
    transform: "translate(-0.287 -2.043)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 31.564,
    height: 0.939,
    transform: "translate(0 11.522)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M28.511,14.224,20.616,5.449l-7.9,8.775h-.039v.042l-.017.021c.017,0,.017,13.393.017,13.393H28.6V14.22Z",
    transform: "translate(-4.833 -2.08)",
    fill: "#ffdc63"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 15.899,
    height: 1.499,
    transform: "translate(7.868 12.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 1.666,
    height: 12.426,
    transform: "translate(7.868 29.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 3.298,
    height: 4.348,
    transform: "translate(7.069 37.972)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 1.666,
    height: 12.426,
    transform: "translate(22.128 29.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 1.666,
    height: 1.424,
    transform: "translate(7.868 29.121)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 1.666,
    height: 1.424,
    transform: "translate(22.128 29.121)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 3.298,
    height: 4.348,
    transform: "translate(21.33 37.972)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M28.854,43.948H11.869l.555-5.112H28.3Z",
    transform: "translate(-4.531 -14.828)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 2.881,
    height: 6.942,
    transform: "translate(4.523 0.266)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 2.881,
    height: 5.23,
    transform: "translate(4.523 1.978)",
    fill: "#79a7ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 3.194,
    height: 0.902,
    transform: "translate(4.368)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 4.095,
    height: 6.34,
    transform: "translate(2.774 14.855)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 3.439,
    height: 5.781,
    transform: "translate(3.115 15.415)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 2.883,
    height: 5.001,
    transform: "translate(3.393 15.764)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M5.488,28.455l2.883-1.7V25.5H6.855l-1.367.806Z",
    transform: "translate(-2.095 -9.736)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M8.372,29.3v-.954L5.488,30.049V31Z",
    transform: "translate(-2.095 -10.821)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 3.008,
    height: 0.172,
    transform: "translate(3.268 17.07)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 4.095,
    height: 6.34,
    transform: "translate(2.774 30.964)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 3.439,
    height: 5.781,
    transform: "translate(3.115 31.523)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 2.883,
    height: 5.001,
    transform: "translate(3.393 31.872)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M5.488,54.512l2.883-1.7V51.556H6.855l-1.367.808Z",
    transform: "translate(-2.095 -19.684)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M8.372,55.353V54.4L5.488,56.1v.953Z",
    transform: "translate(-2.095 -20.77)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 3.008,
    height: 0.171,
    transform: "translate(3.268 33.179)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 4.096,
    height: 6.34,
    transform: "translate(24.86 15.135)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 3.439,
    height: 5.781,
    transform: "translate(25.2 15.694)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 2.883,
    height: 5.001,
    transform: "translate(25.478 16.043)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M41.213,28.908,44.1,27.2V25.952H42.58l-1.367.808Z",
    transform: "translate(-15.735 -9.908)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M44.1,29.749V28.8l-2.883,1.7v.954Z",
    transform: "translate(-15.735 -10.994)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 3.007,
    height: 0.171,
    transform: "translate(25.353 17.35)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 4.096,
    height: 6.34,
    transform: "translate(24.86 30.964)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 3.439,
    height: 5.781,
    transform: "translate(25.2 31.523)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 2.883,
    height: 5.001,
    transform: "translate(25.478 31.872)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M41.213,54.512l2.883-1.7V51.556H42.58l-1.367.808Z",
    transform: "translate(-15.735 -19.684)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M44.1,55.353V54.4l-2.883,1.7v.953Z",
    transform: "translate(-15.735 -20.77)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 3.007,
    height: 0.171,
    transform: "translate(25.353 33.179)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M19.5,5.7l-9.05,10.051L9.735,15.1,19.5,4.272Z",
    transform: "translate(-3.717 -1.631)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M25.53,5.7l9.049,10.051.714-.643L25.53,4.272Z",
    transform: "translate(-9.747 -1.631)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M21.432,30.937v-4.4a2.533,2.533,0,1,1,5.065,0v4.4Z",
    transform: "translate(-8.183 -9.165)",
    fill: "#f09a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M24.206,24.635a2.143,2.143,0,0,0-2.144,2.144v4.009h4.286V26.779a2.144,2.144,0,0,0-2.143-2.144Z",
    transform: "translate(-8.423 -9.406)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M22.935,30.766l.016-3.67a1.588,1.588,0,1,1,3.176,0l-.016,3.67Z",
    transform: "translate(-8.757 -9.722)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 0.211,
    height: 5.473,
    transform: "translate(15.676 15.632)",
    fill: "#35696b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M25.991,14.49A1.19,1.19,0,1,1,24.8,13.3,1.19,1.19,0,0,1,25.991,14.49Z",
    transform: "translate(-9.015 -5.078)",
    fill: "#66adb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 17.154,
    height: 1.231,
    transform: "translate(7.205 28.358)",
    fill: "#58969f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 5.783,
    height: 0.781,
    transform: "translate(12.882 21.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 4.096,
    height: 0.782,
    transform: "translate(24.86 21.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 4.095,
    height: 0.782,
    transform: "translate(2.774 21.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 4.095,
    height: 0.781,
    transform: "translate(2.774 37.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 4.096,
    height: 0.781,
    transform: "translate(24.872 37.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M12.667,15.377,20.6,7.986l8,7.457L20.619,6.575Z",
    transform: "translate(-4.836 -2.51)",
    fill: "#ffc646"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 5.333,
    height: 10.17,
    transform: "translate(13.132 31.241)",
    fill: "#924d48"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 4.62,
    height: 9.31,
    transform: "translate(13.488 31.82)",
    fill: "#724839"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 6.37,
    height: 1.859,
    transform: "translate(12.614 40.462)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 3.828,
    height: 2.083,
    transform: "translate(13.885 32.331)",
    fill: "#6babae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M31.637,53.967a.512.512,0,0,1-1.023,0V51.983a.512.512,0,1,1,1.023,0Z",
    transform: "translate(-11.688 -19.652)",
    fill: "#ffdc63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M19.865,53.967a.512.512,0,0,1-1.023,0V51.983a.512.512,0,1,1,1.023,0Z",
    transform: "translate(-7.194 -19.652)",
    fill: "#ffdc63"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 0.417,
    height: 8.014,
    transform: "translate(8.454 30.964)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 0.416,
    height: 8.014,
    transform: "translate(22.77 30.964)",
    fill: "#fbdecc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 3.298,
    height: 0.789,
    transform: "translate(7.069 37.972)",
    fill: "#fbcaa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 3.298,
    height: 0.789,
    transform: "translate(21.33 37.972)",
    fill: "#fbcaa2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 15.937,
    height: 0.976,
    transform: "translate(7.831 23.466)",
    fill: "#ffc646"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 1.368,
    height: 4.491,
    transform: "translate(30.656 40.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M51.02,62.84a.849.849,0,1,1-.849-.849A.849.849,0,0,1,51.02,62.84Z",
    transform: "translate(-18.831 -23.668)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolighus);
export default __webpack_public_path__ + "static/media/Bolighus.b7a75d7ee19a3cb92e88f4e7e5829242.svg";
export { ForwardRef as ReactComponent };